import React from 'react';

/**
 * Hairline-separated settings group — label in secondary, rows divided by hairline.
 */
export const SettingsGroup = ({ title, description, icon: Icon, children, className = '' }) => (
  <section className={`mb-10 ${className}`}>
    <div className="mb-4">
      {Icon && (
        <div className="flex items-center gap-2 mb-2">
          <Icon className="w-5 h-5 text-pine shrink-0" />
          <h2 className="font-display text-h2 text-primary">{title}</h2>
        </div>
      )}
      {!Icon && title && <h2 className="font-display text-h2 text-primary">{title}</h2>}
      {description && <p className="text-body text-secondary mt-1 max-w-2xl">{description}</p>}
    </div>
    <div className="hairline-list border-t border-hairline">{children}</div>
  </section>
);

export const SettingsRow = ({ label, description, children, className = '' }) => (
  <div className={`flex flex-wrap items-center justify-between gap-4 py-4 ${className}`}>
    <div className="min-w-0 flex-1">
      {label && <p className="text-body text-primary">{label}</p>}
      {description && <p className="text-label text-secondary mt-0.5">{description}</p>}
    </div>
    <div className="shrink-0">{children}</div>
  </div>
);

export const SettingsBlock = ({ children, className = '' }) => (
  <div className={`py-4 ${className}`}>{children}</div>
);

export default SettingsGroup;
